
const NISAR_ITEMS = [
	{
		id: 'nisar_001',
		title: 'صورة بشكل تصاعدي',
		date: '2026-01-09T00:00:00.000Z',
		formatted_date: '2025-12-28 / 2026-01-09',
		description: 'صورة NISAR معروضة على الكرة الأرضية. إحداثيات المركز المطلوبة: 24.7625, 36.0291. حدود العرض المستخدمة: شمال 26.07501، جنوب 23.35487، شرق 39.88518، غرب 36.86058.',
		north_boundary: 50.700698624,
		south_boundary: 6.300852494,
		east_boundary: 62.268207471,
		west_boundary: 16.166367239,
		distance_from_nisar: 5,
		center: '28.871,34.444',
		image_file_name: 'NISAR',
		transparent: true,
		dataset_id: null,
		zoomFactor: 5,
		created_at: '',
		updated_at: '',
		external_id: 'eo_nisar_001',
		imagecategory: 'nisar',
		list_image_src: 'assets/ce2s2_nisar_data/NISAR_GCOV_mosaic_Ascending.png',
		image_src: 'assets/ce2s2_nisar_data/NISAR_GCOV_mosaic_Ascending.png'
	},
	{
		id: 'nisar_002',
		title: 'صورة بشكل تنازلي',
		date: '2026-01-09T00:00:00.000Z',
		formatted_date: '2025-12-28 / 2026-01-09',
		description: 'صورة NISAR معروضة على الكرة الأرضية. إحداثيات المركز المطلوبة: 24.7625, 36.0291. حدود العرض المستخدمة: شمال 26.07501، جنوب 23.35487، شرق 39.88518، غرب 36.86058.',
		north_boundary: 50.478699393,
		south_boundary: 6.078853263,
		east_boundary: 61.417210420,
		west_boundary: 15.315370188,
		distance_from_nisar: 5,
		center: '6.15, 30.49',
		image_file_name: 'NISAR',
		transparent: true,
		dataset_id: null,
		zoomFactor: 5,
		created_at: '',
		updated_at: '',
		external_id: 'eo_nisar_002',
		imagecategory: 'nisar',
		list_image_src: 'assets/ce2s2_nisar_data/NISAR_GCOV_mosaic_Descending.png',
		image_src: 'assets/ce2s2_nisar_data/NISAR_GCOV_mosaic_Descending.png'
	}
];

const getNisarByExternalId = externalId => NISAR_ITEMS.find(item => item.external_id === externalId) || null;

export {
	NISAR_ITEMS,
	getNisarByExternalId
};
